<template>
    <b-modal
        id="school-account-add-user"
        v-model="user_modal"
        :ok-title="$t('common.save')"
        @ok="onSubmit"
        @show="onShow"
        cancel-variant="outline-primary"
        :cancel-title="$t('common.cancel')"
        :title="$t('school.new_user')"
        autocomplete="off"
        modal-class="apprentice-default-modal">
        <div class="create-user">
            <div
                class="errors"
                v-if="!hasError">
                <b-alert
                    variant="warning"
                    show>
                    {{ $t('school.all_fields_except_preposition_are_mandatory_fields') }}
                </b-alert>
            </div>

            <div class="name">
                <b-alert
                    v-if="nameError"
                    show
                    variant="danger"
                    >{{ $t('school.first_name_mandatory') }}</b-alert
                >

                <b-form-group
                    :label="$t('common.first_name')"
                    label-for="name">
                    <b-form-input
                        id="name"
                        v-model="form.name"
                        required
                        :placeholder="$t('common.first_name')"></b-form-input>
                </b-form-group>
            </div>

            <b-alert
                v-if="surnameError"
                show
                variant="danger"
                >{{ $t('validation.last_name_mandatory') }}</b-alert
            >
            <div class="last-name">
                <b-form-group
                    class="preposition-group"
                    :label="$t('common.infix')"
                    label-for="preposition">
                    <b-form-input
                        id="preposition"
                        v-model="form.preposition"
                        :placeholder="$t('common.infix')"></b-form-input>
                </b-form-group>

                <b-form-group
                    class="surname-group"
                    :label="$t('common.last_name')"
                    label-for="surname">
                    <b-form-input
                        id="surname"
                        v-model="form.surname"
                        required
                        :placeholder="$t('common.last_name')"></b-form-input>
                </b-form-group>
            </div>

            <div class="email">
                <b-alert
                    v-if="emailError"
                    show
                    variant="danger"
                    >{{ $t('school.email_address_mandatory') }}
                </b-alert>

                <b-alert
                    v-if="emailDuplicateError"
                    show
                    variant="danger">
                    {{ $t('school.choose_an_other_email_address') }}
                </b-alert>

                <b-form-group
                    label="E-mail:"
                    label-for="email">
                    <b-form-input
                        id="email"
                        v-model="form.email"
                        type="email"
                        required
                        placeholder="E-mail"></b-form-input>
                </b-form-group>
            </div>

            <div class="role">
                <b-alert
                    v-if="roleError"
                    show
                    variant="danger"
                    >{{ $t('school.role_mandatory') }}</b-alert
                >

                <b-form-group
                    label="Rol:"
                    label-for="role">
                    <b-form-select
                        class="apprentice-primary-select"
                        v-model="form.role"
                        required>
                        <option :value="null">{{ $t('school.choose_a_role') }}l</option>
                        <option value="student">{{ $t('school.student') }}</option>
                        <option value="teacher">{{ $t('school.teacher') }}</option>
                    </b-form-select>
                </b-form-group>
            </div>

            <div class="username">
                <b-alert
                    v-if="usernameError"
                    show
                    variant="danger"
                    >{{ $t('accounts.username_mandatory') }}</b-alert
                >

                <b-alert
                    v-if="usernameDuplicateError"
                    show
                    variant="danger">
                    {{ $t('school.choose_an_other_username') }}
                </b-alert>

                <b-form-group
                    :label="$t('common.username')"
                    label-for="username">
                    <b-form-input
                        id="username"
                        v-model="form.username"
                        required
                        :placeholder="$t('common.username')"></b-form-input>
                </b-form-group>
            </div>

            <div class="password">
                <b-form-group
                    :label="$t('common.password')"
                    label-for="password">
                    <b-form-input
                        id="password"
                        v-model="form.password"
                        type="password"
                        required
                        autocomplete="new-password"
                        :placeholder="$t('common.password')"></b-form-input>
                </b-form-group>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-school-accounts-add-account-modal-component',
    data() {
        return {
            user_modal: false,
            form: {
                name: '',
                preposition: '',
                surname: '',
                email: '',
                username: '',
                password: '',
                role: null,
            },
            hasError: false,
            nameError: false,
            surnameError: false,
            emailError: false,
            roleError: false,
            usernameError: false,
            usernameDuplicateError: false,
            emailDuplicateError: false,
        };
    },
    methods: {
        checkForErrors() {
            this.hasError = false;

            for (const [key, data] of Object.entries(this.form)) {
                if (key === 'preposition') {
                    continue;
                }

                if (!data) {
                    this.hasError = true;
                }
            }
        },

        onSubmit(event) {
            this.nameError = this.form.name === '';
            this.emailError = this.form.email === '';
            this.usernameError = this.form.username === '';
            this.roleError = this.form.role === null;
            this.surnameError = this.form.surname === '';

            if (this.checkForErrors()) {
                event.preventDefault();
            }

            event.preventDefault();

            if (this.nameError || this.usernameError || this.roleError || this.surnameError) {
                event.preventDefault();
            } else {
                this.alert.saving();
                this.axios.post('/project/account/store', this.form).then(
                    (response) => {
                        this.user_modal = false;

                        this.$bvModal.hide('school-account-add-user');

                        this.alert.success();
                        this.$emit('user-created');
                    },
                    (error) => {
                        if (error.response.data.errors.email || error.response.data.errors.username) {
                            if (error.response.data.errors.email) {
                                this.emailDuplicateError = true;
                            } else {
                                this.emailDuplicateError = false;
                            }

                            if (error.response.data.errors.username) {
                                this.usernameDuplicateError = true;
                            } else {
                                this.usernameDuplicateError = false;
                            }

                            this.alert.close();
                        } else {
                            this.alert.ajaxError(error);
                        }
                    },
                );
            }
        },

        onShow() {
            this.hasError = false;
            this.form.name = '';
            this.form.surname = '';
            this.form.preposition = '';
            this.form.email = '';
            this.form.username = '';
            this.form.password = '';
            this.form.role = null;
            this.usernameError = false;
            this.roleError = false;
            this.surnameError = false;
            this.nameError = false;
            this.emailError = false;
            this.usernameDuplicateError = false;
            this.emailDuplicateError = false;
        },
    },
};
</script>

<style scoped lang="scss">
.create-user {
    input {
        margin-bottom: 0;
    }

    select {
        margin-bottom: 0;
    }
}

.last-name {
    display: flex;
    flex-direction: column;

    input {
        margin-bottom: 0;
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .last-name {
        align-items: center;
        flex-direction: row;
        justify-content: space-between;

        .preposition-group {
            width: calc(33% - 15px);
        }

        .surname-group {
            width: calc(67% - 15px);
        }
    }
}
</style>
